export enum SetWallboardType {
    SET_WALLBOARD = "SET_WALLBOARD",
}